import {Page} from '../../../components/Page';
import {Button, Tab, Tabs, Theme} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import React, {useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {makeStyles} from '@material-ui/styles';
import PageHeader from '../../../components/PageHeader';
import DocumentEdit from './DocumentEdit';
import {WcvType} from '../../../graphql/logs.datatypes';
import AddNote from '../../Logs/AddNote/AddNote';
import {LogListContent} from '../../Logs/LogList/LogList';
import {getMe} from '../../../graphql/auth';
import {WcvDocument} from '../../../graphql/documents.datatypes';
import getDocument from '../getDocument.api';
import {formatGraphQlDate} from '../../../utils/formatters';
import {DocumentListContent} from '../DocumentsList/DocumentsList';
import {OverdueDocumentListContent} from '../OverdueDocumentsList/OverdueDocumentList';
import {checkIsAdmin} from '../../../utils/checkIsAdmin';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    tabs: {
        marginTop: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    card: {},
    linkButton: {
        marginRight: theme.spacing(1),
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

export const getBlankDocument = (userId: number): WcvDocument => {
    return {
        __typename: 'Document',
        id: -1,
        user_id: userId,
        type: -1,
        type_id: -1,
        title: '',
        description: '',
        url: '',
        has_completion_date: false,
        completion_date: formatGraphQlDate(new Date()),
        available_for_download: false,
        verified: false,
        completed_documents: [],
        tour_role: -1,
    };
};

export const DocumentDetailsContent = (props: { document: WcvDocument, setSelectedDocument?: (document: WcvDocument | undefined) => void, fileTypes?: string, }) => {
    const classes = useStyles();
    const {document, setSelectedDocument, fileTypes} = props;
    const [tab, setTab] = useState('details');
    const [openModal, setOpenModal] = useState(false);
    const isNewDocument = document.id === -1;

    const isAdmin = checkIsAdmin();

    return (
        <div>

            <Tabs className={classes.tabs} onChange={(event, value) => setTab(value)} scrollButtons="auto" value={tab}
                  variant="scrollable">
                <Tab label="Details" value="details"/>
                {!isNewDocument && <Tab label="Completed Documents" value="completed"/>}
                {!isNewDocument && <Tab label="Overdue Members" value="overdue"/>}
                {!isNewDocument && <Tab label="Notes" value="notes"/>}
            </Tabs>

            {tab === 'details' && (
                <DocumentEdit document={document} setSelectedDocument={setSelectedDocument} fileTypes={fileTypes}/>
            )}

            {tab === 'completed' && (
                <DocumentListContent parentDocumentId={document.id} showViewAndVerify={true} isAdmin={isAdmin}/>
            )}

            {tab === 'overdue' && (
                <OverdueDocumentListContent isAdmin={isAdmin}
                                            overdueDocuments={document.overdueGroupMembers ? document.overdueGroupMembers.map(groupMember => ({
                                                document,
                                                groupMember
                                            })) : []}/>
            )}

            {tab === 'notes' && (
                <div>
                    <Button
                        color="primary"
                        onClick={() => setOpenModal(true)}
                        size="small"
                        variant="outlined"
                    >
                        Add Note
                    </Button>
                    <LogListContent type={WcvType.DOCUMENT} type_id={document.id} notes={true}/>
                    {openModal && (<AddNote onClose={() => setOpenModal(false)} type={WcvType.DOCUMENT}
                                            type_id={document.id}/>)}
                </div>
            )}
        </div>
    );
};


const DocumentDetails = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const {id} = match.params;
    const newDocument = id === 'new';
    const meData = getMe();
    const documentData = newDocument ? {
        loading: false,
        data: {document: getBlankDocument(meData.data && meData.data.me && meData.data.me.id || -1)},
        error: null
    } : getDocument(Number(id));
    const {enqueueSnackbar} = useSnackbar();
    const title = 'Document Details';

    useEffect(() => {
        if (documentData.error) {
            enqueueSnackbar(`There was an error loading Document ${id}`, {variant: 'error'});
            history.push('/documents');
        }
    }, [documentData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="docments" title={title}/>
            <LoadingOverlay loading={documentData.loading}>
                {documentData.data && documentData.data.document && (
                    <DocumentDetailsContent document={documentData.data.document}/>)}
            </LoadingOverlay>
        </Page>
    );
};

export default DocumentDetails;
